export class SecretRoutes
{
	static Home: string = "/";

	static SecretList: string = "/secret/list";
	static SecretNew: string = "/secret/new";
	static SecretCopy(id: string)
	{
		return `/secret/${id}/new`
	};
	static SecretEdit(id: string)
	{
		return `/secret/${id}/edit`
	};
	static SecretView(id: string)
	{
		return `/secret/${id}/view`
	};

	static RetrieveNew = "/retrieve/new";
}